import React, { Component } from 'react';
import KeyCodes from '../../constants/KeyCodes';
import PropTypes from 'prop-types';
import style from './style/inlineeditabletext.scss';

export default class InlineEditableText extends Component {
    constructor(props) {
        super(props);

        this.amendInlineEditable = this.amendInlineEditable.bind(this);
        this.keyPressedWhileAmending = this.keyPressedWhileAmending.bind(this);

        this.state = {
            text: this.props.initialValue
        };
    }

    amendInlineEditable(event) {
        event.preventDefault();
        const value = event.currentTarget.value;

        // call amending function when change was detected
        if (value !== this.props.initialValue) {
            this.props.amendFunction(
                this.props.amendSectionType,
                this.props.amendFieldType,
                this.props.id,
                value
            );
        }

        event.currentTarget.blur();
    }

    onChangeInput(event) {
        event.stopPropagation();

        this.setState({
            text: event.target.value || ''
        });
    }

    keyPressedWhileAmending(event) {
        switch (event.keyCode) {

            case KeyCodes.ESCAPE:
                event.currentTarget.value = this.props.initialValue;
                event.currentTarget.blur();
                break;

            case KeyCodes.ENTER:
                event.currentTarget.blur();
                break;

            default:
                break;
        }
    }

    componentDidUpdate(prevProps) {

        // the text field will always show cached text from this.state.text
        // when navigating to another organisation, the initialValue will change
        // and this should be set in the state, to make sure that the new name is shown
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({
                text: this.props.initialValue
            });
        }
    }

    render() {
        const { maxChars, readOnly, classes } = this.props;
        const activeClass = readOnly ? null : style.active;
        const activeClassOverride = readOnly ? null : classes.active;

        return (
            <div
                className={ `${style.amendInlineEditable} ${classes.root} ${activeClass} ${activeClassOverride}` }
            >
                <input
                    type="text"
                    name="name"
                    required
                    value={ this.state.text || '' }
                    onChange={ this.onChangeInput.bind(this) }
                    readOnly={ readOnly }
                    maxLength={ maxChars }
                    autoComplete="off"
                    onBlur={ event => {
                        this.amendInlineEditable(event);
                    } }
                    onFocus={ event => !readOnly && event.stopPropagation() }
                    onClick={ event => !readOnly && event.stopPropagation() }
                    onKeyDown={ event => {
                        this.keyPressedWhileAmending(event);
                    } }
                />
            </div>
        );
    }
}

InlineEditableText.propTypes = {
    initialValue: PropTypes.string.isRequired,
    amendFunction: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    amendSectionType: PropTypes.string.isRequired,
    amendFieldType: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    maxChars: PropTypes.number.isRequired,
    classes: PropTypes.object
};

InlineEditableText.defaultProps = {
    classes: {
        root: '',
        active: ''
    }
};
